module.exports = __webpack_public_path__ + "img/thumb_24.f24f6298.jpg";